const $ = jQuery;
export const initCounterAnimation = () => {
    const $statsCol = $('.frontpage-stats__col');
    if ($statsCol.length > 0) {
        let animationStarted = false; // Flag to indicate if animation has started
        const statsColOffsetTop = $statsCol.offset().top - window.innerHeight; // Position of the stats column

        $(window).scroll(function () {
            if (!animationStarted && $(window).scrollTop() > statsColOffsetTop) {
                animateCounters($statsCol); // Call animation function
                animationStarted = true; // Set flag to prevent re-triggering
            }
        });
    }
};

// Separate function for animating the counters
const animateCounters = ($statsCol) => {
    $statsCol.find('.stats__number').each(function () {
        const $this = $(this);
        const countTo = parseFloat($this.attr('data-count'));
        const integerPart = Math.floor(countTo);
        const hasDecimal = (countTo % 1 !== 0);

        // Start animation based on whether there's a decimal part
        if (hasDecimal) {
            animateWithDecimal($this, integerPart, countTo);
        } else {
            animateWithoutDecimal($this, countTo);
        }
    });
};

// Function for animating with decimals
const animateWithDecimal = ($element, integerPart, countTo) => {
    $({ countNum: 0 }).animate({
        countNum: integerPart
    }, {
        duration: 1500,
        easing: 'swing',
        step: function () {
            $element.text(this.countNum.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
        },
        complete: function () {
            // Animate the integer part to the full number with decimal
            $({ countNum: integerPart }).animate({
                countNum: countTo
            }, {
                duration: 500,
                easing: 'swing',
                step: function () {
                    $element.text(this.countNum.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
                },
                complete: function () {
                    $element.text(countTo.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')); // Final value
                }
            });
        }
    });
};

// Function for animating without decimals
const animateWithoutDecimal = ($element, countTo) => {
    $({ countNum: 0 }).animate({
        countNum: countTo
    }, {
        duration: 2000,
        easing: 'swing',
        step: function () {
            $element.text(Math.floor(this.countNum).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')); // Show only whole numbers with spaces
        },
        complete: function () {
            $element.text(Math.floor(countTo).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')); // Final whole number
        }
    });
};